import styled from 'styled-components';
// import Marquee from 'react-fast-marquee';
import { PageProps } from 'gatsby';
import React, { FC, PropsWithChildren } from 'react';

import Header from '../Header';
import Footer from '../Footer';
import { flexColumn } from '../../styles/helpers';
import { GlobalStyles } from '../../styles/GlobalStyles';
import ShoppingCartLink from '../ShoppingCartLink';
import { PageContext } from '../../contexts/i18nContext';

declare global {
  interface Window {
    gtag(): void;
    dataLayer?: any[];
  }
}

const Wrapper = styled.div`
  ${flexColumn};
`;

const Main = styled.main``;

type TLayout = PropsWithChildren & PageProps;

const Layout: FC<TLayout> = (props) => {
  const { children, pageResources } = props;

  const currentLang = (pageResources?.json.pageContext as PageContext)?.i18n.language;

  return (
    <Wrapper>
      <GlobalStyles />
      <Header />
      {/* <Marquee style={{ backgroundColor: 'black', padding: '10px', display: 'flex' }} speed={100} gradient={false}>
        <span style={{ color: 'white', fontWeight: 'bold', fontSize: '20px', marginRight: '40px' }}>
          -20% on everything · Black Friday Sale · Use code BLACK20
        </span>
        <span style={{ color: 'white', fontWeight: 'bold', fontSize: '20px', marginRight: '40px' }}>
          -20% on everything · Black Friday Sale · Use code BLACK20
        </span>
        <span style={{ color: 'white', fontWeight: 'bold', fontSize: '20px', marginRight: '40px' }}>
          -20% on everything · Black Friday Sale · Use code BLACK20
        </span>
      </Marquee> */}
      <Main>{children}</Main>
      {!pageResources?.page.path?.includes('checkout') && <ShoppingCartLink currentLang={currentLang} />}
      <Footer />
    </Wrapper>
  );
};

export default Layout;
